import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "documentDetails";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const TASK_RESULT_LIMIT = {
    MIN: 10,
    MAX: 2 ** 16 - 1,
    STEPS: [10, 100, 1000, 5000, 2 ** 16 - 1]
};
